import CwLoadModules from '@customjs/module-loader.js';

const CwThemeFramework = {
    async generalFns() {
        const office = document.querySelector('.select-office');
        if (office) {
            this.loadLocations(office);
            office.addEventListener('change', () => this.loadLocations(office));
            office.addEventListener('click', () => {
                const selectedOption = office.options[office.selectedIndex];
                if (
                    selectedOption &&
                    selectedOption.getAttribute('data-by-appointment-only') === 'true' &&
                    !selectedOption.textContent.match(/\(By Appointment Only\)/i)
                ) {
                    selectedOption.textContent = selectedOption.textContent.trim() + ' (By Appointment Only)';
                }
            });
        }

    },

    /**
     * Load Locations
     */
    async loadLocations(locationID) {
        if (locationID) {
            CwLoadModules.modals().then((modals) => {
                const officeHours = new modals('.cw-modal');
                officeHours.init();
            });
            const apiURL = `/api/location/${locationID.value}/`;
            const officeBox = document.querySelector('.office-info');
            const officeHours = document.querySelector('.opening-hours');
            const officeInfo = await fetch(apiURL);
            const officeDetails = await officeInfo.json();
            const footerMapDesktop = document.querySelector('.footer-map-desktop');
            const selectWrapper = document.querySelector('.select-office-wrapper');

            if (officeDetails.success) {
                const {
                    firmName,
                    directionURL,
                    city,
                    state,
                    zip,
                    location_address_1,
                    location_address_2,
                    phone,
                    email,
                    toll_free_number,
                    location_fax,
                    footer_map,
                    footer_tablet_map_image,
                    footer_mobile_map_image,
                    monday_hours,
                    tuesday_hours,
                    wednesday_hours,
                    thursday_hours,
                    friday_hours,
                    saturday_hours,
                    sunday_hours,
                    office_by_appointment_only,
                } = officeDetails.data;

                 // Only append "(By Appointment Only)" to the *currently selected* option if its data attribute is set
                 const select = selectWrapper.querySelector('.select-office');
                 if (select) {
                     const selectedOption = select.options[select.selectedIndex];
                     if (
                         selectedOption &&
                         selectedOption.getAttribute('data-by-appointment-only') === "true" &&
                         !selectedOption.textContent.match(/\(By Appointment Only\)/i)
                     ) {
                         selectedOption.textContent = selectedOption.textContent.trim() + ' (By Appointment Only)';
                     }
                 }
 
                // If office_by_appointment_only is true, add "By Appointment Only" message to the select office wrapper
                if (office_by_appointment_only && selectWrapper) {
                    let existing = selectWrapper.querySelector('.by-appointment-only-msg');
                    selectWrapper.classList.add('by-appointment-only');
                    if (!existing) {
                        const byApptDiv = document.createElement('div');
                        byApptDiv.className = 'by-appointment-only-msg';
                        byApptDiv.textContent = 'By Appointment Only';
                        selectWrapper.appendChild(byApptDiv);
                    }

                    // Remove "(By Appointment Only)" from select option label if present
                    const select = selectWrapper.querySelector('.select-office');
                    if (select) {
                        for (const option of select.options) {
                            option.textContent = option.textContent.replace(/\s*\(By Appointment Only\)\s*/i, '');
                        }
                    }
                } else if (selectWrapper) {
                    // Remove message if it exists and appointment only is not set
                    selectWrapper.classList.remove('by-appointment-only');
                    let existing = selectWrapper.querySelector('.by-appointment-only-msg');
                    if (existing) {
                        existing.remove();
                    }
                    
                }


                const firmNameHTML = '';
                const address1HTML = location_address_1 ?
                    `<span>${location_address_1}</span>` :
                    '';
                const address2HTML = location_address_2 ?
                    `<span>${location_address_2}</span>` :
                    '';
                const phoneHTML = phone ?
                    `<a href="tel:${phone}" class="ctm-no-swap" aria-label="Phone">Phone: ${phone}</a>` :
                    '';
                const emailHTML = email ?
                    `<a href="mailto:${email}" aria-label="Email Address">Email: ${email}</a>` :
                    '';
                const officeInfoButtons = `<div class="office-info__buttons">
                   <a href="${directionURL}" target="_blank" aria-label="Direction Link">Directions</a>
                   <button class="btn cw-modal" data-cw-target="#hoursModal" id="office-hours">Calls are Answered 24/7</button>
               </div>`;

                let footerMapHTML = '';

                if (footer_mobile_map_image) {
                        footerMapHTML += `<figure class="d-md-none"><a href="${directionURL}" target="_blank" aria-label="Direction Link"><img src="${footer_mobile_map_image}" alt="${firmName}" /></a></figure>`;
                }

                if (footerMapDesktop) {
                    footerMapDesktop.innerHTML = `<figure class="d-md-none d-xl-block"><a href="${directionURL}" target="_blank" aria-label="Direction Link"><img src="${footer_map}" alt="${firmName}" /></a></figure>`;
                }

                if (footer_tablet_map_image) {
                    footerMapHTML += `<figure class="d-none d-md-block d-xl-none"><a href="${directionURL}" target="_blank" aria-label="Direction Link"><img src="${footer_tablet_map_image}" alt="${firmName}" /></a></figure>`;
                }

                const address = `${firmNameHTML}
               <address>
                   ${address1HTML}
                   ${address2HTML}<br>
                   <span>${city}, ${state} ${zip}</span><br>
               </address>
               ${phoneHTML}<br>
               ${emailHTML}${officeInfoButtons}
               ${footerMapHTML}`;
                officeBox.innerHTML = address;

                const mondayHoursHTML = monday_hours ?
                    `<tr><td class="day">Monday</td><td class="time"><span>${monday_hours}</span></td></tr>` :
                    '';
                const tuesdayHoursHTML = tuesday_hours ?
                    `<tr><td class="day">Tuesday</td><td class="time"><span>${tuesday_hours}</span></td></tr>` :
                    '';
                const wednesdayHoursHTML = wednesday_hours ?
                    `<tr><td class="day">Wednesday</td><td class="time"><span>${wednesday_hours}</span></td></tr>` :
                    '';
                const thursdayHoursHTML = thursday_hours ?
                    `<tr><td class="day">Thursday</td><td class="time"><span>${thursday_hours}</span></td></tr>` :
                    '';
                const fridayHoursHTML = friday_hours ?
                    `<tr><td class="day">Friday</td><td class="time"><span>${friday_hours}</span></td></tr>` :
                    '';
                const saturdayHoursHTML = saturday_hours ?
                    `<tr><td class="day">Saturday</td><td class="time"><span>${saturday_hours}</span></td></tr>` :
                    '';
                const sundayHoursHTML = sunday_hours ?
                    `<tr><td class="day">Sunday</td><td class="time"><span>${sunday_hours}</span></td></tr>` :
                    '';

                const hoursOffice = `<table>
                              <tbody>
                              ${mondayHoursHTML}
                              ${tuesdayHoursHTML}
                              ${wednesdayHoursHTML}
                              ${thursdayHoursHTML}
                              ${fridayHoursHTML}
                              ${saturdayHoursHTML}
                              ${sundayHoursHTML}
                              </tbody>
                            </table>`;

                // Hours Modal
                officeHours.innerHTML = hoursOffice;
            }
        }
    },

    /**
     * Mobile Menu
     */
    mobileMenu() {
        const mobileButton = document.querySelector('.mobile-button');
        const mobileMenuElement = document.querySelector('#mmenu');
        const mobileChecker = document.querySelector('.mm-ocd');

        if (mobileButton && mobileMenuElement) {
            // Call mmenujs module
            CwLoadModules.mmenu().then((MmenuLight) => {
                if (!mobileChecker) {
                    const menu = new MmenuLight(mobileMenuElement);
                    menu.navigation();
                    const drawer = menu.offcanvas();

                    // Register event for listening to clicks
                    mobileButton.addEventListener('click', () => drawer.open());

                    /**
                     * Close Button
                     */
                    const closeButton = document.querySelector('.close__mobileMenu');

                    closeButton.addEventListener('click', () => drawer.close());

                    /**
                     *  Appending a click option for link tags
                     * with a hash(#) symbol at the beginning of the href
                     * */

                    const aHashTag = mobileMenuElement.querySelectorAll('a[href="#"]');
                    aHashTag.forEach((tag) => {
                        tag.addEventListener('click', (event) => {
                            event.target.parentNode.click();
                            event.preventDefault();
                        });
                    });
                }
            });
        }
    },
};

export default CwThemeFramework;